import { ColDef } from 'ag-grid-community';

import { GridService } from 'tms-lib';

export function getCollectionProductColumnDefs(gridService: GridService): ColDef[] {
  return [
    gridService.text('productKey', $localize`Product`),
    gridService.text('productDescription', $localize`Description`),
    gridService.text('collectionKey', $localize`Collection`),
    gridService.text('collectionDescription', $localize`Collection Description`),
  ];
}
